import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Feedback from '../../feedbacks';
import { FEEDBACK_NOT_FOUND } from '../../constants/feedbackNames';
import { FRONT_PAGE_PATH } from '../../constants/paths';
import NOB from '../../constants/language-strings';
import './infobox.scss';
export default function InfoBox({ feedback, firstInfoBoxLine, link, secondInfoBoxLine, thirdInfoBoxLine, }) {
    return (_jsxs("div", { className: "info-box", children: [_jsxs("div", { className: "info-box__text", children: [_jsx("h1", { children: firstInfoBoxLine }), _jsx("h2", { children: secondInfoBoxLine }), _jsx("h2", { children: thirdInfoBoxLine })] }), link ? (_jsxs("div", { className: "info-box__feedback", children: [feedback || _jsx(Feedback, { name: FEEDBACK_NOT_FOUND }), _jsx(Link, { to: FRONT_PAGE_PATH, children: NOB.NO_WORK_ORDERS.TO_FRONT_PAGE })] })) : (feedback)] }));
}
InfoBox.defaultProps = {
    feedback: null,
    firstInfoBoxLine: '',
    link: true,
    secondInfoBoxLine: NOB.INFO_BOX.NOT_EXIST,
    thirdInfoBoxLine: '',
};
InfoBox.propTypes = {
    feedback: PropTypes.element,
    firstInfoBoxLine: PropTypes.string,
    link: PropTypes.bool,
    secondInfoBoxLine: PropTypes.string,
    thirdInfoBoxLine: PropTypes.string,
};
